module.exports = __webpack_public_path__ + "img/pdf.05526f1b.svg";